import React from 'react'
import {useRouterQuery} from 'app/lib/useRouterQuery'
import {useContractQuery} from 'app/_server/queries/contracts'
import Loading from 'app/Components/Loading'
import {
	DetailsHeaderPanel,
	DetailsImagePanel,
} from '../ReservationDetails/Components'
import {SummaryCard} from '../Components'
import {OverviewPanel} from '../ReservationSummary/Components'
import {
	AdditionalOptionsPanel,
	ConfirmationPageHeader,
	DateRangePanel,
	GuestsPanel,
	InsurancePanel,
	NewsletterPanel,
} from './Components'

export const Details = ({
	contract,
}: {
	contract: Pick<
		Contract,
		| 'adults'
		| 'babies'
		| 'beginDate'
		| 'client'
		| 'endDate'
		| 'hasInsurance'
		| 'house'
		| 'kids'
		| 'options'
	>
}) => {
	if (!contract) return null
	const {house} = contract || {}

	return (
		<div className="flex w-full flex-col gap-8">
			<DetailsImagePanel house={house} />
			<div className="flex w-full flex-col gap-6">
				<DetailsHeaderPanel contract={contract} />
				<DateRangePanel contract={contract} />
				<GuestsPanel contract={contract} />
				<AdditionalOptionsPanel contract={contract} />
				<InsurancePanel contract={contract} />
			</div>
		</div>
	)
}

const ConfirmationPage = () => {
	const {searchParams} = useRouterQuery()
	const {id: contractId} = searchParams
	const {data, loading} = useContractQuery(
		{id: contractId},
		{skip: !contractId}
	)

	if (!contractId) return <div>Contract ID not found</div>
	if (!data && loading) return <Loading />

	const {contract} = data || {}
	if (!contract) return <div>Contract not found</div>

	return (
		<div className="flex w-full flex-col gap-8 p-8">
			<ConfirmationPageHeader contract={contract} />
			<div className="gap-4lg:flex-row flex w-full flex-col items-start justify-center gap-4 lg:flex-row">
				<SummaryCard
					title="ConfirmationDetailsLabel"
					classNameInner="flex flex-col gap-4 pt-3"
					classNameWrap="w-full bg-capGoldLight"
				>
					<Details contract={contract} />
				</SummaryCard>
				<SummaryCard
					title="CostOverviewLabel"
					classNameInner="flex flex-col gap-4 pt-3"
					classNameWrap="w-full"
				>
					<OverviewPanel contract={contract} />
				</SummaryCard>
				<SummaryCard
					title="subscribeHeader"
					classNameInner="flex flex-col gap-4 pt-3"
					classNameWrap="w-full"
				>
					<NewsletterPanel />
				</SummaryCard>
			</div>
		</div>
	)
}

export default ConfirmationPage
